import { Component, Input } from '@angular/core';
import { cn } from '../../../../utils/utils';

@Component({
  selector: 'contact-avatar',
  standalone: true,
  imports: [],
  templateUrl: './contact-avatar.component.html',
  styleUrl: './contact-avatar.component.css',
})
export class ContactAvatarComponent {
  @Input() firstName: string = '';
  @Input() lastName: string = '';
  @Input() avatarUrl: string = '';
  @Input() class: string = '';
  @Input() InitialClass: string = '';

  merge = cn;


  /** First letters of the first and last name; never "undefined". */
  get Inititals(): string {
    const first = (this.firstName || '').trim().charAt(0);
    const last = (this.lastName || '').trim().charAt(0);
    return (first + last).toUpperCase();
  }
}
